import appStore from '../assets/app-store.png'
import googlePlay from '../assets/google-play.png'
import { track } from '../utils/analytics'

export const AppDownloadButtons = (): JSX.Element => {
  const trackClick = () => track('GoToApp', 'Go to app')
  return (
    <div className='flex gap-3'>
      <a
        target='_blank'
        rel='noopener noreferrer'
        href='https://apps.apple.com/app/id1613247966'
        onClick={trackClick}
      >
        <img width={150} src={appStore} />
      </a>

      <a
        target='_blank'
        rel='noopener noreferrer'
        href='https://play.google.com/store/apps/details?id=com.ridebelay.belay'
        onClick={trackClick}
      >
        <img width={150} src={googlePlay} />
      </a>
    </div>
  )
}
